<template>
  <a
    :href="href"
    class="btn btn-primary btn-block py-3 text-lg font-bold transform hover:scale-105 transition"
    @click="$emit('checkout')">
    🚀 {{ $t("checkout.finalize") }}
  </a>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
const props = defineProps<{ href: string }>();
</script>
